package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_01_14_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Breakfast together downstairs in the Leering Stag before our meeting. Gorem leads us to the Magistrate. There are two human guards. We go to a conference room. The Magistrate is named Rafe Creel. He is a 54 year old human. Also present, Damon the bard. First we discuss some of the strange happenings.  Rafe reports that scouts have detected some things")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Animals left dead unharvested")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Could it be rabid animals?")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A nefarious being?")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Animals were pierced or slashed (not Arcane-d) Rafe offers us a contract to investigate the disappearance of the two brothers and four guards.  350g for any info leading to return. We ask Rafe for some background")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("2 Brothers are named Mel and Bog Crond")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Professions: Gathers of Wood / Woodsmen, but not employed by a lumber mill. They harvest/collect wood and deliver it to one of a few lumber mills and are paid upon delivery.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The guards were traveling east when they disappeared.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mel & Bog are in their early 30. No Family.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mel & Bog kept to themselves. But the town is small. Everyone knows who they are. They were not antisocial psychopaths or anything.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mel & Bog have been in town for 7 years.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Rafe not sure if they attend a church.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Rafe not sure if they are involved in any sports.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Their home is on the North side of town.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The guards were not experienced (so maybe they are just lost or fell into a simple trap? All of the group signed the contract. The meeting lasts ~1 hour. It is now 11-11:30am-ish.")
        }
    }
}
